import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

export const OptionsMenu = ({
  isOpen,
  title,
  options = [],
  activeValue,
  onSelect,
  onRequestClose,
  anchorRef,
  className = 'auto-run-settings-menu',
  headerClassName = 'auto-run-settings-menu__header',
  itemClassName = 'auto-run-settings-menu__item',
  activeItemClassName = 'auto-run-settings-menu__item--active',
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleOutsideClick = (event) => {
      const clickedInsideMenu = menuRef.current?.contains(event.target);
      const clickedInsideAnchor = anchorRef?.current?.contains?.(event.target);

      if (!clickedInsideMenu && !clickedInsideAnchor) {
        onRequestClose?.();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onRequestClose?.();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onRequestClose, anchorRef]);

  if (!isOpen) return null;

  return (
    <div className={className} ref={menuRef}>
      {title && (
        <div className={headerClassName}>
          <span>{title}</span>
        </div>
      )}

      {options.map((option) => (
        <button
          key={option.value}
          className={`${itemClassName} ${
            option.value === activeValue ? activeItemClassName : ''
          }`}
          onClick={() => onSelect(option.value)}
          type='button'
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

OptionsMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  activeValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func,
  anchorRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  activeItemClassName: PropTypes.string,
};

export default OptionsMenu;
